module.exports = __webpack_public_path__ + "images/emoji/shirt.77a0455d981735f7a82b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/shirt.png
// module id = eBpa
// module chunks = 14